import { isSeededFeatureFlagOn } from '../../../helpers/seededFeatureFlags';

// Sync read of the treatment seeded into `<head>`, so the filter source is right on the first search:
// `useSplit` is async and returns `false` while pending. Only on once lucee and pybynder seed it.
export const isShareableUrlSplitOn = (): boolean =>
	isSeededFeatureFlagOn('assetbank_shareable_url');
